module.exports = __webpack_public_path__ + "c3c7c36db6e60101631eab7a68433bf1.pdf";